import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import NavBar from '../components/NavBar/NavBar';
import Footer from '../components/Footer/Footer';

const PaymentCancelled: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [paymentType, setPaymentType] = useState<string>('champion');

  useEffect(() => {
    const type = searchParams.get('type');
    if (type) {
      setPaymentType(type);
    }
  }, [searchParams]);

  const handleRetryPayment = () => {
    // 根据支付类型返回对应页面
    if (paymentType === 'karma') {
      navigate('/user-center?tab=karma');
    } else {
      // Champion 支付 - 返回上一个小说页面
      const novelId = localStorage.getItem('currentNovelId') || '7';
      navigate(`/book/${novelId}`);
    }
  };

  const handleReturnToHome = () => {
    navigate('/');
  };

  return (
    <div style={{ background: '#18191A', minHeight: '100vh', color: '#fff', fontFamily: 'inherit' }}>
      <NavBar />
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
        <div style={{ textAlign: 'center', maxWidth: '600px', padding: '20px' }}>
          {/* 取消图标 */}
          <div style={{ fontSize: '64px', marginBottom: '24px' }}>
            🚫
          </div>
          
          {/* 标题 */}
          <h1 style={{ fontSize: '32px', marginBottom: '16px', color: '#ff9800' }}>
            Payment Cancelled
          </h1>
          
          {/* 描述 */}
          <p style={{ fontSize: '18px', marginBottom: '24px', color: '#ccc' }}>
            You have cancelled the payment process. No charges have been made to your account.
          </p>
          
          {/* 信息卡片 */}
          <div style={{ 
            background: '#2a2a2a', 
            padding: '16px', 
            borderRadius: '8px', 
            marginBottom: '32px',
            border: '1px solid #ff9800'
          }}>
            <h3 style={{ margin: '0 0 12px 0', color: '#ff9800' }}>
              💡 What would you like to do?
            </h3>
            <p style={{ margin: '0', fontSize: '14px', color: '#ccc' }}>
              {paymentType === 'karma' 
                ? 'You can return to the Karma purchase page to try again or choose a different package.'
                : 'You can return to the novel page to try again or choose a different subscription tier.'
              }
            </p>
          </div>

          {/* 操作按钮 */}
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button 
              onClick={handleRetryPayment}
              style={{
                padding: '12px 24px',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '600'
              }}
            >
              {paymentType === 'karma' ? 'Return to Karma' : 'Return to Novel'}
            </button>
            <button 
              onClick={handleReturnToHome}
              style={{
                padding: '12px 24px',
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '600'
              }}
            >
              Return to Homepage
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PaymentCancelled;
